import { render, staticRenderFns } from "./IconContentLock.vue?vue&type=template&id=2d1d11eb"
import script from "./IconContentLock.vue?vue&type=script&lang=js"
export * from "./IconContentLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports